// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const computerClient = createTypedClient();
export const createComputerClient = (config) => createTypedClient(config);
